import { useCallback } from 'react';
import { useParams } from 'react-router';
import { ShiftTypeService } from 'src/api/ShiftTypeService';
import type { ShiftType, ShiftTypeRequest } from 'src/api/ShiftTypeService';
import { invalidateShiftTypes } from '@stores/shiftTypeStore';

type SaveShiftType = (
    shiftType: ShiftTypeRequest,
    shiftTypeId?: string,
) => Promise<ShiftType | undefined>;

const useSaveShiftType = (): { saveShiftType: SaveShiftType } => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const saveShiftType = useCallback<SaveShiftType>(
        async (shiftType, shiftTypeId) => {
            if (!departmentId) {
                throw new Error(
                    'useSaveShiftType requires a departmentId route param',
                );
            }

            const savedShiftType = shiftTypeId
                ? await ShiftTypeService.updateShiftType(
                      departmentId,
                      shiftTypeId,
                      shiftType,
                  )
                : await ShiftTypeService.createShiftType(
                      departmentId,
                      shiftType,
                  );

            if (!savedShiftType) {
                return undefined;
            }

            invalidateShiftTypes(departmentId);

            return savedShiftType;
        },
        [departmentId],
    );

    return { saveShiftType };
};

export default useSaveShiftType;
